import $ from "@modules/jquery";

$(document).ready(function() {
    //
});
